// jshint esversion:6

import React, { Component, useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import Sidebar from "../Components/Sidebar/Sidebar";
import { auth } from "../firebase";
import { Router, Redirect, withRouter } from "react-router-dom";
import { Route } from "react-router-dom";
import { Usertypes } from "../Helpers/constants";
import Apilib from "../api";
// import './style.css';
import "./style.scss";
import { SplashLoader } from "../Components/Loader/Loader";
import { useStateValue } from "../StateProvider";

const MobileLayout = ({ children, type, path, user, userData, ...rest }) => {
  return (
    <>
      <link rel="stylesheet" type="text/css" href={"assets/css/style.css"} />
      <div className="main-wrapper">
        {/* <div className="page-wrapper"> */}
        <div className="content2">{children}</div>
        {/* </div> */}
      </div>
      <div className="sidebar-overlay" data-reff=""></div>
    </>
  );
};

const MobileLayoutRoute = ({
  component: Component,
  userType,
  path,
  ...rest
}) => {
  const [redirect, setRedirect] = useState(null);
  const [user, setUser] = useState();
  const [userData, setUserData] = useState("loading");
  const [userDisplayName, setUserDisplayName] = useState(true);
  const [{ userPP }, dispatch] = useStateValue();

  function updateUser(user) {
    setUser(user);
  }

  useEffect(() => {
    let isSubscribed = true;
    let API = new Apilib();
    auth.onAuthStateChanged((user) => {
      if (user) {
        if (localStorage.getItem('@displayName') == userType) {
          API.getUserDetails(localStorage.getItem('@displayName'), user.uid)
            .then((res) => res.json())
            .then((res) => {
              if (isSubscribed) {
                setUser(user);
                setUserDisplayName(localStorage.getItem('@displayName'));
                setUserData(res.user);
                setRedirect(null);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          if (isSubscribed) {
            setUser(null);
            setRedirect(Usertypes[localStorage.getItem('@displayName') - 1][1]);
          }
        }
      } else {
        setRedirect("/Login");
      }
    });
    API.getLocation()
      .then((res) => res.json())
      .then((res) => {
        dispatch({
          type: "SET_LOCATION",
          lat: res.latitude,
          long: res.longitude,
          country_code: res.country_code,
        });
      })
      .catch((err) => {
        console.log("geoError", err);
      });
    return () => (isSubscribed = false);
  }, [auth]);

  if (redirect) {
    return <Redirect to={redirect} />;
  } else if (userData == "loading") {
    return (
      <>
        <SplashLoader />
      </>
    );
  } else {
    return (
      <Route
        {...rest}
        render={(matchProps) => (
          <MobileLayout
            user={user}
            userData={userData}
            path={path}
            type={userDisplayName}
          >
            <Component
              type={userDisplayName}
              userData={userData}
              updateUser={updateUser}
              user={user}
              {...matchProps}
            />
          </MobileLayout>
        )}
      />
    );
  }
};

export default MobileLayoutRoute;
